module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-voxi-intro-card1.1@2x.81f5ce34.jpg";